import { UserStageModel } from './user-stage.model';
export class UserStageRequest {

    public userEditVos : UserStageModel[];
    constructor(userEditVos : UserStageModel[]) {
      this.userEditVos = userEditVos;
    }
}
